<template>
    <div class="remain-module">
        <div class="tab-box">
            <van-tabs v-model="activeName" id="tabs" class="top-tab" animated @change="tabChange" title-inactive-color="#A0ACB5">
                <!-- 卡余明细 -->
                <van-tab title-class="main-tab" title="卡余明细" :name="REMAIN_DETAIL_TAB.CARD">
                    <div class="line"></div>
                    <div class="card-remain">
                        <div class="top-box flex flex-y-center flex-between">
                            <div class="box flex flex-col flex-x-center flex-y-center">
                                <img class="top-icon" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/money-icon.png" alt="" />
                                <div class="top-num">{{ cardDetail.balance }}万</div>
                                <div class="top-txt">当前卡余</div>
                            </div>
                            <div class="box flex flex-col flex-x-center flex-y-center">
                                <img class="top-icon" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/recharge.png" alt="" />
                                <div class="top-num">{{ cardDetail.sumPrice }}万</div>
                                <div class="top-txt">累计充值金额</div>
                            </div>
                            <div class="box flex flex-col flex-x-center flex-y-center">
                                <img class="top-icon" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/num-icon.png" alt="" />
                                <div class="top-num">{{ cardDetail.sumNext }}</div>
                                <div class="top-txt">累计充值次数</div>
                            </div>
                        </div>
                        <div class="list-tab-box" id="inner-tab">
                            <van-tabs id="card-tab" active="" line-width="25px" line-height="4px" color="#2FD0D5" title-active-color="#35434C" title-inactive-color="#A0ACB5" animated>
                                <van-tab title="会员卡" name="members">
                                    <div class="list-box" v-if="cards.length">
                                        <div :class="`${item.companyCode != 25002 ? 'card-box' : 'bls-card-box'}`" v-for="(item, index) in cards" :key="index">
                                            <!-- 美田卡样式 -->
                                            <div v-if="item.companyCode != 25002">
                                                <img class="card-logo" :src="item.cardIcon" alt="" />
                                                <img class="card-img" :src="item.backgroundUrl" alt="" />
                                                <div class="card-type font32">{{ item.cardAlias }}</div>
                                                <div class="card-store font24">{{ item.storeName }}</div>
                                                <div class="card-num">{{ item.cardNo }}</div>
                                                <div class="card-balance flex flex-y-center">
                                                    <div class="font24 padding-right-xs">余额</div>
                                                    <div class="font40">¥{{ item.remainPar }}</div>
                                                </div>
                                            </div>
                                            <!-- 贝丽诗卡样式 -->
                                            <div v-else class="flex flex-x-center" :style="`color:${item.fontColor}`">
                                                <img class="bls-card-img" :src="item.backgroundUrl" alt="" />
                                                <div class="bls-card-type font24">{{ item.cardAlias }}&nbsp;&nbsp;<span class="bls-card-num">{{ item.cardNo }}</span></div>
                                                <div class="bls-card-store font24">{{ item.storeName }}</div>

                                                <div class="bls-card-balance flex flex-y-center bold">
                                                    <div class="font32 ">余额：</div>
                                                    <div class="font32">¥{{ item.remainPar }}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-else>
                                        <van-empty img="https://static.beautyfarm.com.cn/vip_admin/icon/empty4.png" description="暂无数据" />
                                    </div>
                                </van-tab>
                                <van-tab title="充值明细" name="recharge">
                                    <template v-if="rechargeDetail.length">
                                        <div class="recharge-box flex flex-x-center" v-for="(item, index) in rechargeDetail" :key="index">
                                            <div class="recharge-inner flex flex-between">
                                                <div class="recharge-left flex-col flex-between ">
                                                    <div class="font32 Blacks bold">{{ item.storeName }}</div>
                                                    <div class="font28 Greys">{{ item.createDate }}</div>
                                                </div>
                                                <div>
                                                    <div class="recharge-right flex-y-center">
                                                        <div class="font36 red">¥{{ item.amount }}</div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </template>
                                    <div v-else>
                                        <van-empty img="https://static.beautyfarm.com.cn/vip_admin/icon/empty4.png" description="暂无数据" />
                                    </div>
                                </van-tab>
                            </van-tabs>
                        </div>
                    </div>
                </van-tab>
                <!-- 消费明细 -->
                <van-tab title-class="main-tab" title="消费明细" :name="REMAIN_DETAIL_TAB.CONSUME">
                    <div class="line"></div>
                    <div class="consume-remain">
                        <div class="list-tab-box" id="inner-tab">
                            <div class="box-line"></div>
                            <van-tabs id="consume-tab" @change="onConsumeChanges" line-width="25px" line-height="4px" :active="currentConsumeType" color="#2FD0D5" title-active-color="#35434C" title-inactive-color="#A0ACB5" animated>
                                <van-tab v-for="(tabItem, index) in tabOrderList" :title="tabItem.title" :name="tabItem.consumeType" :key="index">
                                    <template v-if="consumeDetail.length && currentConsumeType != 5">
                                        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getConsumeDetail" :immediate-check="false">
                                            <div class="collapse-box" v-for="(item, index) in consumeDetail" :key="index">
                                                <div class="collapse-title flex flex-between flex-y-center mb-20" @click="changeCollapse(item)">
                                                    <div class="flex-1 font32 Blacks bold">{{ item.channelName }}</div>
                                                    <div class="title-time font32 Red">¥{{ item.payedAmt }}</div>
                                                </div>
                                                <div class="collapse-title flex flex-between flex-y-center" @click="changeCollapse(item)">
                                                    <div class="flex-1  font28 Greys">{{ item.createTime }}</div>
                                                    <van-icon v-if="item.expande == true" name="arrow-up" color="#A0ACB5" class="font28" />
                                                    <van-icon v-else name="arrow-down" color="#A0ACB5" class="font28" />
                                                </div>
                                                <div :class="`collapse-inner Blacks ${item.expande == true ? 'block' : ''}`">
                                                    <div class="flex flex-between flex-y-center mb-10" v-for="oItem, index in item.consumeContentDTOList" :key="index">
                                                        <div>{{ oItem.prodName }}</div>
                                                        <div class="price">¥{{ oItem.prodPrice }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </van-list>
                                    </template>
                                    <!-- 积分 -->
                                    <div class="integral-select-box flex-between flex-y-center" v-if="currentConsumeType == 5">
                                        <div class="change-year-tab flex-y-center">
                                            <div :class="`change-year-item  ${detailTabIndex == 1 ? 'active' : ''}`" @click="clickTab(1)">积分明细</div>
                                            <div :class="`change-year-item  ${detailTabIndex == 2 ? 'active' : ''}`" @click="clickTab(2)">她能兑换</div>
                                        </div>
                                        <div class="select-box flex flex-y-center flex-start">
                                            <div class="select-item flex-between flex-y-center" @click="selectTypePopup">
                                                <div class="select-tit">{{ checkedType && checkedType.name }}</div>
                                                <van-icon name="play" class="select-arrow" />
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="(currentConsumeType == 5 && detailTabIndex == 1 && integralDetail.length) || (currentConsumeType == 5 && detailTabIndex == 2 && herIntegralList.length)">
                                        <!-- 积分明细 -->
                                        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getIntegralDetail" :immediate-check="false" v-if="detailTabIndex == 1">
                                            <div class="collapse-box" v-for="(item, index) in integralDetail" :key="index">
                                                <div class="collapse-title flex flex-between flex-y-center mb-20" @click="changeCollapse(item)">
                                                    <div class="flex-1 font32 Blacks bold">{{ item.showName }}</div>
                                                    <div class="title-time font32 Red">
                                                        <span>{{ item.processType == 1 ? '+' : '-' }}</span>{{ item.changeAmount }}
                                                    </div>
                                                </div>
                                                <div class="collapse-title flex flex-between flex-y-center" @click="changeCollapse(item)">
                                                    <div class="flex-1  font28 Greys">{{ item.createTime }}</div>
                                                    <van-icon v-if="item.expande == true && item.eventCode == 'orderDeduct'" name="arrow-up" color="#A0ACB5" class="font28" />
                                                    <van-icon v-else-if="item.expande != true && item.eventCode == 'orderDeduct'" name="arrow-down" color="#A0ACB5" class="font28" />
                                                </div>
                                                <div :class="`collapse-inner Blacks ${item.expande == true ? 'block' : ''}`" v-if="item.eventCode == 'orderDeduct'">
                                                    <div class="flex flex-between flex-y-center">
                                                        <div>{{ item.remark }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </van-list>
                                        <!-- 她能兑换 -->
                                        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getConsumeDetail" :immediate-check="false" v-if="detailTabIndex == 2">
                                            <div class="her-box flex-between flex-y-center" v-for="(item, index) in herIntegralList" :key="index">
                                                <div class="her-box-title flex-y-center">{{ item.title }}</div>
                                                <div class="her-box-num flex-end">
                                                    <div>{{ item.portionIntegral }}积分+{{ item.portionPrice }}元</div>
                                                    <div v-if="item.allIntegralPrice != 0">或{{ item.allIntegralPrice }}元</div>
                                                </div>
                                            </div>
                                        </van-list>
                                    </template>
                                    <div v-else style="margin-top: 200px">
                                        <van-empty img="https://static.beautyfarm.com.cn/vip_admin/icon/empty4.png" description="暂无数据" />
                                    </div>
                                </van-tab>
                            </van-tabs>
                        </div>
                    </div>
                </van-tab>
                <!-- 院余明细 -->
                <van-tab title-class="main-tab" title="院余明细" :name="REMAIN_DETAIL_TAB.COURT">
                    <div class="line"></div>
                    <div class="court-remain">
                        <div class="list-tab-box" id="inner-tab">
                            <van-tabs id="court-tab" @change="onYuanChange" line-width="25px" line-height="4px" color="#2FD0D5" title-active-color="#35434C" title-inactive-color="#A0ACB5" animated>
                                <van-tab v-for="tabItem in tabList" :title="tabItem.title" :name="tabItem.storagesType" :key="tabItem.storagesType">
                                    <template v-if="storagesDetail.length">
                                        <div v-for="item in storagesDetail" :key="item.storageNo" :class="['court-box', 'flex', 'flex-between', item.statusFlag == 3 ? 'gray' : '']">
                                            <img v-if="item.isGift == '1'" class="give-icon" alt="" src="../../assets/img/zeng-yuan.png" />
                                            <div class="overdue-icon" v-if="item.statusFlag == 3">已过期</div>
                                            <div class="court-name-box flex flex-col flex-x-center">
                                                <div class="font32 mb-20">{{ item.prodName }}</div>
                                                <div class="font28">有效期至{{ item.availableDate }}</div>
                                            </div>
                                            <div class="flex-1 flex-y-center flex-end font24">
                                                <span>剩余</span>
                                                <span class="font34 red"> {{ item.remainTimes }} </span>
                                                <span>次</span>
                                            </div>
                                        </div>
                                    </template>
                                    <div v-else style="margin-top: 200px">
                                        <van-empty img="https://static.beautyfarm.com.cn/vip_admin/icon/empty4.png" description="暂无数据" />
                                    </div>
                                </van-tab>
                            </van-tabs>
                        </div>
                    </div>
                </van-tab>
                <!-- 券余明细 -->
                <van-tab title-class="main-tab" title="券余明细" :name="REMAIN_DETAIL_TAB.TICKET">
                    <div class="line"></div>
                    <div class="ticket-remain">
                        <div class="list-tab-box" id="inner-tab">
                            <van-tabs id="court-tab" @change="onQuanChange" line-width="25px" line-height="4px" color="#2FD0D5" title-active-color="#35434C" title-inactive-color="#A0ACB5" animated>
                                <van-tab v-for="tabItem in tabList" :title="tabItem.title" :name="tabItem.consumeType" :key="tabItem.consumeType">
                                    <template v-if="couponsDetail.length">
                                        <div class="ticket-box flex flex-between" v-for="(item, index) in couponsDetail" :key="index">
                                            <img v-if="item.isGift == '1'" class="give-icon" src="../../assets/img/zeng-yuan.png" />
                                            <div class="ticket-price">
                                                <img class="ticket-img" v-if="item.statusFlag == '1'" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/ticket.png" />
                                                <img class="ticket-img" v-else-if="item.statusFlag == '3'" src="../../assets/img/overdue.png" />
                                                <div class="symbol font24">¥</div>
                                                <div class="num font40">{{ item.remainPar }}</div>
                                                <div class="txt font24">余额</div>
                                            </div>
                                            <div class="flex-1 ticket-inner flex flex-col flex-x-center">
                                                <div class="mb-10 font30 Blacks bold">{{ item.couponName }}</div>
                                                <div class="mb-10 font24 Grey">有效期至 {{ item.availableDate }}</div>
                                                <div class="mb-10 font24 Grey">类型：{{ item.couponClassName }}</div>
                                                <div class="mb-10 font24 Grey">剩余次数：{{ item.remainTimes }}次</div>
                                            </div>
                                        </div>
                                    </template>
                                    <div v-else style="margin-top: 200px">
                                        <van-empty img="https://static.beautyfarm.com.cn/vip_admin/icon/empty4.png" description="暂无数据" />
                                    </div>
                                </van-tab>
                            </van-tabs>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
            <van-popup v-model="showTypePopup" round position="bottom" closeable class="popup" get-container="#app">
                <picker title="选择类型" v-model="checkedType" :list="typeList" @change="onTypeChange"></picker>
            </van-popup>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import { REMAIN_DETAIL_TAB } from './components/config'
    import Picker from '@/components/Picker';

    export default {
        name: "remainDetail",
        components: {
            Picker
        },
        data() {
            return {
                activeName: '',
                REMAIN_DETAIL_TAB,
                cards: [],
                rechargeDetail: [],
                cardDetail: {},
                consumeDetail: [],
                consumePageNum: 1,
                currentConsumeType: 1,
                loading: false,
                finished: false,
                tabOrderList: [
                    { title: "生美", consumeType: 1, storagesType: 51 },
                    { title: "医美", consumeType: 2, storagesType: 54 },
                    { title: "抗衰", consumeType: 3, storagesType: 55 },
                    { title: "线上", consumeType: 4, storagesType: 56 },
                    { title: "积分", consumeType: 5, storagesType: 56 },
                ],
                tabList: [
                    { title: "生美", consumeType: 1, storagesType: 51 },
                    { title: "医美", consumeType: 2, storagesType: 54 },
                    { title: "抗衰", consumeType: 3, storagesType: 55 },
                ],
                currentStoragesType: 51,
                currentCouponsType: 1,
                storagesDetail: [],
                couponsDetail: [],
                integralDetail: [], //积分明细列表
                integralPageNum: 1,
                detailTabIndex: 1,
                showTypePopup: false,// 选择类型弹窗
                checkedType: { id: '0', name: '全部' },//所选类型
                balanceAmount: 0, //剩余积分
                herIntegralList: [], //她能兑换列表
                custId: '',
                accountNo: ''
            };
        },
        mounted() {
            console.log(this.$route.query);

            const { tabName, custId, currentConsumeType, balanceAmount, accountNo } = this.$route.query
            this.activeName = tabName
            this.custId = custId
            this.balanceAmount = balanceAmount || 0
            this.accountNo = accountNo || ''
            this.currentConsumeType = currentConsumeType || 1
            this.init();
        },
        computed: {
            typeList() { // 类型列表
                if (this.detailTabIndex == 1) {
                    return [
                        {
                            name: '全部',
                            id: "0"
                        },
                        {
                            name: '获得',
                            id: "1"
                        },
                        {
                            name: '支出',
                            id: "2"
                        },
                        {
                            name: '退款扣减',
                            id: "3"
                        },
                        {
                            name: '过期',
                            id: "4"
                        }
                    ]
                } else if (this.detailTabIndex == 2) {
                    return [
                        {
                            name: '全部',
                            id: "0"
                        },
                        {
                            name: '项目兑换',
                            id: "1"
                        },
                        {
                            name: '礼品兑换',
                            id: "2"
                        }
                    ]
                }
            }
        },
        methods: {
            init() {
                this.getCardDetail();
                this.getCards();
                this.getRechargeDetail();
                if (this.currentConsumeType == 5) {
                    if (this.detailTabIndex == 1) {
                        this.getIntegralDetail();
                    } else {
                        this.getHerIntegral();
                    }
                } else {
                    this.getConsumeDetail();
                }
                this.getStoragesDetail();
                this.getCouponsDetail();
            },
            getCardDetail() {
                return request({
                    url: `/member/cardDetail?custId=` + this.custId,
                    method: "get",
                })
                    .then((res) => {
                        this.cardDetail = res.data;
                    })
                    .catch(() => {
                        this.cardDetail = [];
                    });
            },
            getCards() {
                return request({
                    url: `/member/cards?custId=` + this.custId,
                    method: "get",
                })
                    .then((res) => {
                        this.cards = res.data || [];
                    })
                    .catch(() => {
                        this.cards = [];
                    });
            },
            getRechargeDetail() {
                return request({
                    url: `/member/rechargeDetail?custId=` + this.custId,
                    method: "get",
                })
                    .then((res) => {
                        this.rechargeDetail = res.data.list;
                    })
                    .catch(() => {
                        this.rechargeDetail = [];
                    });
            },
            onConsumeChanges(consumeType) {
                this.consumeDetail = [];
                this.consumePageNum = 1;
                this.currentConsumeType = consumeType;
                this.finished = false;
                if (this.currentConsumeType == 5) {
                    if (this.detailTabIndex == 1) {
                        this.getIntegralDetail();
                    } else {
                        this.getHerIntegral();
                    }
                } else {
                    this.getConsumeDetail();
                }
            },
            getConsumeDetail() {
                request({
                    url: `/member/consumeDetail?custId=${this.custId}&page=${this.consumePageNum}&type=${this.currentConsumeType}`,
                    method: "get",
                })
                    .then((res) => {
                        const list = res.data.list.map((item) => ({ ...item, expande: false }));
                        this.consumeDetail = this.consumeDetail.concat(list);
                        if (list.length === 0) {
                            this.finished = true;
                        }
                        this.consumePageNum += 1;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 消费-积分明细
            getIntegralDetail() {
                request({
                    url: `/index/accountBalance/balanceInfoPage?accountNo=${this.accountNo}&page=${this.integralPageNum}&type=${this.checkedType && this.checkedType.id}`,
                    method: "get",
                })
                    .then((res) => {
                        const list = res.data.list.map((item) => ({ ...item, expande: false }));
                        this.integralDetail = this.integralDetail.concat(list);
                        if (list.length === 0) {
                            this.finished = true;
                        }
                        this.integralPageNum += 1;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 消费-她能兑换
            getHerIntegral() {
                request({
                    url: `/index/accountBalance/integral?integralVal=${this.balanceAmount}&tags=${this.checkedType && this.checkedType.id}`,
                    method: "get",
                })
                    .then((res) => {
                        this.herIntegralList = res.data
                        if (res.data === 0) {
                            this.finished = true;
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            changeCollapse(row) {
                row.expande = !row.expande;
            },
            getStoragesDetail() {
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    overlay: true,
                    duration: 0, // 持续展示 toast
                    loadingType: 'spinner',
                });
                request({
                    url: `/member/storages?custId=${this.custId}&type=${this.currentStoragesType}`,
                    method: "get",
                })
                    .then((res) => {
                        this.storagesDetail = res.data;
                    })
                    .catch(() => {
                        this.storagesDetail = [];
                    }).finally(() => {
                        Toast.clear();
                    })
            },
            onYuanChange(storagesType) {
                this.storagesDetail = [];
                this.currentStoragesType = storagesType;
                this.getStoragesDetail();
            },
            onQuanChange(type) {
                this.couponsDetail = [];
                this.currentCouponsType = type;
                console.log(this.currentCouponsType);
                this.getCouponsDetail();
            },
            getCouponsDetail() {
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    overlay: true,
                    duration: 0, // 持续展示 toast
                    loadingType: 'spinner',
                });
                return request({
                    url: `/member/coupons?custId=${this.custId}&type=51&dimension=${this.currentCouponsType}`,
                    method: "get",
                })
                    .then((res) => {
                        this.couponsDetail = res.data;
                    })
                    .catch(() => {
                        this.couponsDetail = [];
                    }).finally(() => {
                        Toast.clear();
                    })
            },
            tabChange(tabName) {
                const query = JSON.parse(JSON.stringify(this.$route.query))
                query.tabName = tabName;
                this.$router.replace({ query })
            },
            // tab事件
            clickTab(tabIndex) {
                this.detailTabIndex = tabIndex
                this.checkedType = { id: '0', name: '全部' }
                this.onRefresh()
            },
            // 筛选相关
            onTypeChange(data) {
                this.checkedType = data;
                this.showTypePopup = false;
                this.onRefresh();
            },
            selectTypePopup() {
                this.showTypePopup = true
            },
            onRefresh() {
                if (this.detailTabIndex == 1) {
                    this.integralPageNum = 1
                    this.integralDetail = []
                    this.getIntegralDetail();
                } else {
                    this.herIntegralList = []
                    this.getHerIntegral();
                }
                console.log('page', this.integralPageNum);
                this.finished = false;
                // 重新加载数据
                this.loading = true;
            },
        },
    };
</script>
<style lang="less" scoped>
    .red {
        color: #ff7777;
    }

    .remain-module {
        width: 750px;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .tab-box {
        margin-bottom: 20px;
        background: #fff;
        box-shadow: inset 0px 2px 10px -11px rgba(0, 0, 0, 0.8);
    }

    .tab-box .line {
        height: 20px;
        background-color: #f9fafc;
    }

    :deep(#tabs > .van-tabs__wrap) {
        height: 130px;
    }

    :deep(#tabs > .van-tabs__nav) {
        position: relative;
        display: flex;
        height: 130px;
        -webkit-user-select: none;
        user-select: none;
        padding: 0 30px;
    }

    :deep(#tabs .main-tab) {
        &.van-tab--active .van-tab__text--ellipsis {
            /* width: 184px !important; */
            height: 70px !important;
            padding: 0px 20px !important;
            line-height: 70px;
            background: #2fd0d5 !important;
            border-radius: 35px !important;
            color: #fff !important;
        }

        +.van-tabs__line {
            background-color: transparent !important;
        }
    }

    /* 卡余明细 */
    .card-remain {
        width: 100%;
        background-color: #fff;
        padding-top: 30px;
    }

    .top-box {
        width: 690px;
        height: 227px;
        background: #ffffff;
        box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
        border-radius: 30px;
        margin: 0 auto;
    }

    .top-box .box {
        width: 33%;
        height: 100%;
    }

    .top-box .top-icon {
        width: 40px;
        height: 40px;
        margin-bottom: 10px;
    }

    .top-box .top-num {
        font-size: 36px;
        font-weight: 500;
        color: #35434c;
        margin-bottom: 4px;
    }

    .top-box .top-txt {
        font-size: 26px;
        font-weight: 400;
        color: #a0acb5;
    }

    .list-tab-box {
        margin-top: 30px;
        padding-bottom: 50px;
        position: relative;
    }

    .box-line {
        width: 690px;
        height: 1px;
        background: #d7d7d7;
        opacity: 0.5;
        position: absolute;
        top: 55px;
        margin: 0 30px;
    }

    :deep(#card-tab > .van-tabs__wrap) {
        height: 66px;
    }

    :deep(#inner-tab .van-tabs .van-tab--active > .van-ellipsis) {
        height: 70px !important;
        line-height: 70px;
        background: #fff !important;
        border-radius: 0 !important;
        color: #35434c !important;
    }

    :deep(#inner-tab .van-tabs .van-tabs__line) {
        bottom: -12px;
        background-color: #2fd0d5 !important;
    }

    :deep(#inner-tab .van-tabs .van-tabs__nav) {
        height: 42px;
        padding: 0 !important;
    }

    :deep(#inner-tab .van-tabs .van-tab) {
        flex: 0 0 15% !important;
        padding: 0 !important;
        height: 40px !important;
        line-height: 40px !important;
        color: #a0acb5;
    }

    :deep(.van-tab--active) {
        font-weight: normal;
    }

    :deep(#inner-tab .van-tab__pane-wrapper) {
        margin-right: 2px;
    }

    .card-box {
        width: 690px;
        height: 398px;
        position: relative;
        margin: 20px auto;
    }

    .bls-card-box {
        width: 664px;
        height: 354px;
        position: relative;
        margin: 20px auto;
    }

    .card-img {
        width: 690px;
        height: 398px;
    }

    .bls-card-img {
        width: 664px;
        height: 354px;
    }

    .card-logo {
        position: absolute;
        left: 40px;
        top: 40px;
        width: 173px;
        height: 72px;
    }

    .gold-txt {
        color: #6e542b;
    }

    .card-type {
        position: absolute;
        right: 40px;
        top: 40px;
    }

    .bls-card-type {
        position: absolute;
        left: 48px;
        top: 281px;
    }

    .bls-card-store {
        position: absolute;
        right: 19px;
        top: 20px;
    }

    .card-store {
        position: absolute;
        right: 40px;
        top: 87px;
    }

    .bls-white {}

    .bls-card-num {
        text-align: center;
        font-size: 24px;
    }

    .card-num {
        width: 100%;
        position: absolute;
        left: 0px;
        top: 173px;
        text-align: center;
        font-size: 47px;
    }

    .card-txt {
        position: absolute;
        right: 189px;
        bottom: 49px;
    }

    .card-balance {
        position: absolute;
        bottom: 40px;
        right: 30px;
    }

    .bls-card-balance {
        position: absolute;
        top: 206px;
        left: 48px;
    }

    .recharge-box {
        width: 100%;
        margin: 20px auto;
    }

    .recharge-right {
        margin-top: 28px;
        display: flex;
        align-items: baseline;
    }

    .recharge-inner {
        width: 690px;
        height: 165px;
        background: #ffffff;
        padding: 30px 0;
        border-bottom: 1px solid #d7d7d7;
    }

    /* ----消费明细 */
    .consume-remain {
        width: 100%;
        background-color: #fff;
    }

    .collapse-box {
        width: 690px;
        min-height: 184px;
        background: #ffffff;
        box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
        border-radius: 12px;
        padding: 40px 0;
        margin: 0 auto 20px;
    }

    .her-box {
        width: 690px;
        height: 164px;
        background: #ffffff;
        box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
        border-radius: 12px;
        margin: 20px auto;
        padding: 40px 36px 40px 30px;

        .her-box-title {
            width: 376px;
            font-weight: 500;
            font-size: 30px;
            color: #35434c;
        }

        .her-box-num {
            width: 220px;
            font-weight: 400;
            font-size: 30px;
            color: #f45252;
            text-align: center;
        }
    }

    .integral-select-box {
        padding: 0 30px;
        margin-bottom: 40px;
    }

    .select-box {
        .select-tit {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }
    }

    .change-year-tab {
        width: 300px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;

        .change-year-item {
            width: 160px;
            height: 58px;
            border-radius: 35px;
            font-size: 28px;
            text-align: center;
            color: #a0acb5;
            line-height: 58px;
            background: #f5f5f5;
            z-index: 98;
        }

        .change-year-item.active {
            color: #ffffff;
            background: #2fd0d5;
            z-index: 99;
        }
    }

    .collapse-title {
        padding: 0 30px;
    }

    .collapse-inner {
        margin-top: 20px;
        display: none;
        padding: 20px 30px 0 30px;
        font-size: 28px;
        border-top: 1px solid #d7d7d7;
    }

    .collapse-inner.block {
        display: block;
    }

    .title-icon {
        width: 32px;
        height: 32px;
        margin-right: 20px;
    }

    .title-time {
        width: 190px;
        text-align: right;
    }

    .collapse-inner .price {
        min-width: 130px;
        text-align: right;
    }

    /* 院余明细 */
    .court-remain {
        width: 100%;
        background-color: #fff;
    }

    .court-box {
        width: 690px;
        height: 185px;
        background: #ffffff;
        box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
        border-radius: 12px;
        padding: 40px 40px;
        margin: 20px auto;
        position: relative;
        color: #000;

        .give-icon {
            position: absolute;
            left: 0;
            top: 0;
            width: 124px;
            height: 99px;
        }

        .overdue-icon {
            position: absolute;
            right: 0;
            top: 0;
            width: 116px;
            height: 60px;
            color: #ff9200;
            text-align: center;
            line-height: 60px;
            font-size: 26px;
            border-radius: 0 12px 0 12px;
            background-color: #ffe3cb;
        }
    }

    .court-box.gray {
        color: #a0acb5;
    }

    .court-name-box {
        width: 475px;
    }

    /* 券余 */
    .ticket-remain {
        padding: 0 30px 50px 30px;
        background-color: #fff;
    }

    .ticket-box {
        width: 690px;
        height: 230px;
        background: #ffffff;
        box-shadow: 6px 6px 12px 0px rgba(0, 0, 0, 0.05);
        border-radius: 30px;
        margin: 0px auto;
        margin-bottom: 20px;
        position: relative;

        .give-icon {
            position: absolute;
            left: 0;
            top: 0;
            width: 124px;
            height: 99px;
            z-index: 99;
        }
    }

    .ticket-price {
        width: 180px;
        height: 230px;
        position: relative;
        color: #fff;
    }

    .ticket-price .symbol {
        position: absolute;
        top: 56px;
        left: 31px;
    }

    .ticket-price .num {
        position: absolute;
        width: 180px;
        text-align: center;
        top: 71px;
        font-weight: 700;
    }

    .ticket-price .txt {
        position: absolute;
        bottom: 60px;
        left: 66px;
    }

    .ticket-inner {
        padding: 20px;
        height: 230px;
    }

    .ticket-img {
        width: 180px;
        height: 230px;
    }
</style>
